export default __webpack_public_path__ + "d337ec09f9d70b0158e1f910883709fa.svg";